module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fmh",
    attrs: {
      "id": "map"
    }
  }, [_vm._v("LIST OF MAPS")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter2#map1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1  Leggett and Smith vs. Wheeler and Cleburne")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter3#map2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2  General Hood’s Battle Plan")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter3#map3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3  Atlanta Battlefield")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter4#map4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4  Opening of Battle: Bate vs. Sweeny")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter5#map5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5  Walker vs. Sweeny and Fuller")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter6#map6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6  Cleburne vs. Giles Smith")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter7#map7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7  Maney vs. Giles Smith")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter7#map8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8  Smith’s Brigade Penetrates Gap")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter7#map9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9  Cleburne Attacks Bald Hill")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter8#map10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10  Diversionary Assault by Cheatham’s Corps")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter8#map11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11  Four Confederate Brigades Breach the XV Corps Line")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter9#map12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12  Logan Rallies to Restore Line")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter10#map13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13  Maney & Cleburne Assault Bald Hill")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-27c16829","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/map.vue
// module id = 69
// module chunks = 0